import PropTypes from 'prop-types';
const MomentDate = PropTypes.shape({
  format: PropTypes.func
});
export default MomentDate;